import {findIndex, isArray, isInteger} from 'lodash'
import MixinStringManipulation from '../MixinStringManipulation'
import {sortBy} from 'lodash/collection'
import Vue from 'vue'
import {useRulesStore} from '@/stores/RulesStore'
import {mapWritableState} from 'pinia'
import constants from '@/assets/js/constants'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import MixinConfig from '@/mixins/database/MixinConfig'

export default {
    computed: {
        ...mapWritableState(useRulesStore, {
            rules: 'rules',
        }),
    },
    mixins: [MixinStringManipulation, MixinGenericComponent, MixinConfig],
    methods: {

        getDefaultStrictEndValue() {
            return 0
        },

        replaceTheRuleKeyWith(existingKey, newKey) {

            let self = this

            let itemIndex = findIndex(self.rules, {key: existingKey})

            if (itemIndex !== -1) {
                Vue.set(self.rules[itemIndex], 'key', newKey)
            }

        },

        /*---------------------------------------------
            Time Condition
        ----------------------------------------------*/

        /**
         *
         * The time condition could be a string or an element from an array. If it's an array, pop the element, for string set it to empty array for the sake of consistency, and transition to array. Instead of using the combination of String and Array.
         *
         * @param ruleKey
         * @param timeConditionKey
         *
         * ** Do not have the default value as false, as the check **
         *
         */
        deleteTheTimeCondition(ruleKey, timeConditionKey = '') {

            let self = this

            let itemIndex = findIndex(self.rules, {key: ruleKey})

            if (itemIndex !== -1) {

                // It's important for the check here to not be on boolean as the key could be 0. if we use boolean, it will be false for 0, which is not what we want. 0 is an index we want to use.
                if (typeof timeConditionKey !== 'undefined' && typeof timeConditionKey === 'number') {
                    self.rules[itemIndex]['value'].time_condition.splice(timeConditionKey, 1)
                    // self.currentSelectedRule.time_condition = self.rules[itemIndex].value.time_condition
                    Vue.set(self.currentSelectedRule, 'time_condition', self.rules[itemIndex].value.time_condition)
                } else {
                    // self.rules[itemIndex].value.time_condition = []
                    // self.currentSelectedRule.time_condition = []
                    Vue.set(self.rules[itemIndex][value], 'time_condition', [])
                    Vue.set(self.currentSelectedRule, 'time_condition', [])
                }

            }

        },

        deleteTheQuota(ruleKey) {

            let self = this

            let itemIndex = findIndex(self.rules, {key: ruleKey})

            if (itemIndex !== -1) {

                Vue.set(self.rules[itemIndex].value, 'quota', '')
                Vue.set(self.currentSelectedRule, 'quota', '')

            }

        },

        addTimeCondition(ruleKey, days, startTime, endTime, strictEnd, flexible, timeAllowed, weekly) {

            let self = this

            let itemIndex = findIndex(self.rules, {key: ruleKey})
            let currentTimeCondition = self.rules[itemIndex].value.time_condition

            if (itemIndex !== -1) {

                let filteredDays = days.filter(function (el) {
                    return (el != null && el !== '' && el !== ',')
                })

                let daysStr = filteredDays.join(',')
                daysStr = daysStr.replaceAll(',', '')

                if (typeof currentTimeCondition === 'undefined' || currentTimeCondition === '') {
                    currentTimeCondition = []
                }

                currentTimeCondition.push({
                    days: daysStr,
                    from: startTime,
                    to: endTime,
                    strict_end: strictEnd,
                    flexible: flexible,
                    time_allowed: timeAllowed,
                    weekly: weekly
                })

                Vue.set(self.rules[itemIndex].value, 'time_condition', currentTimeCondition)
                Vue.set(self.currentSelectedRule, 'time_condition', currentTimeCondition)

            }

        },


        setTimeConditionValueForString(currentTimeCondition, self, itemIndex, newTimeCondition, operation) {

            if (currentTimeCondition.length > 0) {

                if (operation === 'edit') {

                    // It's a string and it's an edit which means, we do not need to keep the currentTimeCondition. i.e. the old value.
                    // If a string is updated, this also upgrades it to an array. For the sake of consistency from the data type's standpoint.

                    Vue.set(self.rules[itemIndex].value, 'time_condition', [newTimeCondition])
                    Vue.set(self.currentSelectedRule, 'time_condition', [newTimeCondition])
                } else if (operation === 'add') {
                    Vue.set(self.rules[itemIndex].value, 'time_condition', [currentTimeCondition, newTimeCondition])
                    Vue.set(self.currentSelectedRule, 'time_condition', [currentTimeCondition, newTimeCondition])
                }

            } else {
                // TODO: Log error
            }

        },

        /**
         *
         */
        editTimeCondition(ruleKey, tcIndex, days, from, to, strictEnd, flexible, timeAllowed, weekly) {

            let self = this

            let itemIndex = findIndex(self.rules, {key: ruleKey})

            if (itemIndex !== -1) {

                let currentTimeCondition = self.rules[itemIndex].value.time_condition

                if (tcIndex > -1 && typeof tcIndex != 'undefined' && isInteger(tcIndex)) {

                    let filteredDays = days.filter(function (el) {
                        return (el != null && el !== '' && el !== ',')
                    })

                    let daysStr = filteredDays.join(',')

                    daysStr = daysStr.replaceAll(',', '')

                    let updatedTimeCondition = {
                        days: daysStr,
                        from: from,
                        to: to,
                        strict_end: strictEnd,
                        flexible: flexible,
                        time_allowed: timeAllowed,
                        weekly: weekly
                    }

                    Vue.set(currentTimeCondition, tcIndex, updatedTimeCondition);
                }

                Vue.set(self.rules[itemIndex]['value'], 'time_condition', currentTimeCondition)
                Vue.set(self.currentSelectedRule, 'time_condition', currentTimeCondition)

            } else {
                console.log('Error: Rule not found')
            }

        },

        /**
         * TODO: retire this, and rather use MixinTimeCondition
         */
        prepareTimeConditionValue(timeConditionDaysArray, startTime, endTime, strictEnd) {

            let self = this

            let timeCondition = ''

            if (timeConditionDaysArray.length > 0) {

                // So that instead of storing days as 642, we save as 246
                timeConditionDaysArray = timeConditionDaysArray.sort()

                timeConditionDaysArray.forEach(function (day) {
                    timeCondition += String(day)
                })

            }

            if (startTime && endTime) {
                timeCondition += ' ' + startTime + '-' + endTime
            }

            if (typeof strictEnd === 'undefined') {
                strictEnd = self.getDefaultStrictEndValue()
            }

            timeCondition += ' ' + strictEnd

            return timeCondition

        },

        extractDaysStartAndEndTimeFromString(str) {

            let self = this

            if (str && str.indexOf(' ') !== -1) {

                let pieces = str.split(' ')

                if (pieces.length >= 2) {

                    let timeConditionFullString = pieces[1]
                    let timeConditionPieces = timeConditionFullString.split('-')

                    if (timeConditionPieces.length === 2) {

                        let startTime = self.prependHourLeadingZeroFor24HoursTimeFormat(timeConditionPieces[0])
                        let endTime = self.prependHourLeadingZeroFor24HoursTimeFormat(timeConditionPieces[1])

                        let days = pieces[0]
                        let daysArray = [...days].sort()

                        let strictEnd = self.getDefaultStrictEndValue()

                        if (pieces.length === 3) {
                            let strictEnd = pieces[2]
                        }

                        return {
                            days,
                            daysArray,
                            startTime,
                            endTime,
                            strictEnd
                        }

                    } else {
                        // TODO: Log error
                    }

                } else {
                    // TODO: Log error
                }

            } else {
                // TODO: Log error
            }

            return false

        },

        configRulesHasDomainInDestDomainsAlready(key, domain) {

            let index = findIndex(this.rules, {key})
            return (index !== -1) ? this.rules[index]['value']['dest_domains'].includes(domain) : false

        },

        configRulesPushToRuleDestDomains(key, destDomain) {
            this.rules.map(rule => (rule.key === key) ? rule.value.dest_domains.push(destDomain.replace(constants.fullAccessText, '').trim()) : null)
        }

    }

}
